export const LOADING_DURATIONS = {
  paymentProcessing: [0, 750, 1500] as const,
  serviceIdSteps: [250, 500, 900, 1300, 1600] as const,
  serviceIdComplete: 1750,
  nis2EvalStepMs: 750,
  wizardInit: [0, 900, 2000] as const,
  caenLookupMin: 1750,
  nis2Start: 4500,
  reportGen: 1500,
} as const;
